import { Command, Transaction } from "prosemirror-state";
import { MentionNodeAttributes } from "../schema/marks/mention";
import { MentionInputSuggestion } from "client/Components/MentionInput/useMentions";
import { Mark, Schema } from "prosemirror-model";
import { LinkMarkAttributes } from "../schema/marks/link";

export type MentionConfigurationPattern = (value: string, mentionType: string) => string;

export type RichTextEditorMentionConfiguration = {
	kind: "explicit-mention";
} | {
	kind: "insert-anchor";
	hrefPattern: MentionConfigurationPattern;
};

export function insertMentionExplicitly(
	schema: Schema<never, "mention">,
	from: number,
	to: number,
	type: string,
	suggestion: MentionInputSuggestion
): Command {
	return (state, dispatch): boolean => {
		if (dispatch) {
			const tr: Transaction = state.tr;

			const mentionMarkAttrs: MentionNodeAttributes = {
				type,
				value: suggestion.data
			};

			const mark: Mark = schema.marks
				.mention
				.create(mentionMarkAttrs);

			tr.replaceWith(
				from,
				to,
				[
					schema.text(
						suggestion.text,
						[mark]
					),
				]
			);

			dispatch(tr.scrollIntoView());
		}

		return true;
	};
}

export function insertMentionAsLink(
	schema: Schema<never, "link">,
	from: number,
	to: number,
	type: string,
	suggestion: MentionInputSuggestion,
	hrefPattern: MentionConfigurationPattern
): Command {
	return (state, dispatch): boolean => {
		if (dispatch) {
			const tr: Transaction = state.tr;

			const linkAttrs: LinkMarkAttributes = {
				href: hrefPattern(suggestion.data, type),
				openInANewWindow: false,
				mentionType: type,
				mentionValue: suggestion.data
			};

			const mark: Mark = schema.marks
				.link
				.create(linkAttrs);

			tr.replaceWith(
				from,
				to,
				[
					schema.text(
						suggestion.text,
						[mark]
					),
				]
			);

			dispatch(tr.scrollIntoView());
		}

		return true;
	};
}